export const TOTAL = 'Total';
